import React, {useState} from "react";
import { Button, Checkbox, Control, Field } from "@allxsmith/bestax-bulma";
import axios from "axios";
import {useDispatch} from "react-redux";
import {createSetDataFreshAction} from "../../../../actions/dataActions";
import useInlineEditButton from "../../../../hooks/useInlineEditButton";
import useEditableTableTextAreaCell from "../../../../hooks/useEditableTableTextAreaCell";
import {Link} from "react-router-dom";

function HireReadyRow({value, finance, activeTab, dataFresh, onChange, index, onSave}) {
  const dispatch = useDispatch();
  const [editable, setEditable] = useState(false);
  const [qcEditable, setQcEditable] = useState(false);

  const onQcSave = e => {
      const conf = {
          url: "api/vehicles/qc",
          method: "put",
          data: value
      };
      axios(conf).then(res => {
          dispatch(createSetDataFreshAction(dataFresh + 1));
          setEditable(false);
      })
  }

  const onQcCheck = (e) => {
      let newVehicle ={...value};
      newVehicle.qc_check_received = !newVehicle.qc_check_received;
      onChange(index, newVehicle);
  }

  const handleChange = (e) => {
      let newVehicle = {...value, [e.target.name]: e.target.value};
      onChange(index, newVehicle);
  };

  const handleSave = () => {
      onSave(value);
      setEditable(false);
  }

  const getColor = () => {
      if(value.qc_check_received){
          return "table-highlight-green-black-text"
      }
      else if(value.upcoming_job){
          return "table-highlight-orange"
      }
      //else if(value.sales_prep){
      //   return "table-highlight-dark-red"
      //}
  }


  return (
      <tr
        className={`clickable ${getColor()}`}
        onClick={() => window.open("/editvehicle/" + value.id, "_self")}
        key={value.id}
      >
          <td data-testid={"vehicle-registration"}>
            <Link to={`/editvehicle/${value.id}`}>
              <span className="registration-field">
              {value.registration}
              </span>
            </Link>
          </td>
          {activeTab === 'fleet' &&
            <td data-testid={"vehicle-fleetnum"}>{value.fleet_number}</td>
          }
          <td data-testid={"vehicle-make"}>{value.make}</td>
          <td data-testid={"vehicle-model"}>{value.model}</td>
          <td data-testid={"vehicle-variant"}>{value.variant}</td>
          {useEditableTableTextAreaCell({
              propName: "hire_ready_comments",
              value: value.hire_ready_comments,
              onChange: handleChange,
              onSave: handleSave,
              editable,
              setEditable,
              inlineEdit: true
          })}
          <td data-testid={"vehicle-status"}>{value.vehicle_status}</td>
          <td data-testid={"vehicle-department"}>{value.department}</td>
          <td data-testid={"vehicle-job-description"}>{value.job_description}</td>
          <td data-testid={"vehicle-key"}>{value.key ? value.key : "None Set"}</td>
          <td data-testid={"vehicle-qc-check"} onClick={e => e.stopPropagation()}>
              <Field className={"has-addons"}>
                  <Control>
                      <Checkbox
                        checked={value.qc_check_received}
                        name={"qc_check_received"}
                        onChange={onQcCheck}
                        disabled={!qcEditable}
                      />
                  </Control>
                  {useInlineEditButton({
                      show: true,
                      onSave: onQcSave,
                      setEditable: setQcEditable,
                      editable: qcEditable
                  })}
              </Field>
          </td>
          <td data-testid={"vehicle-type"}>{value.type}</td>
          <td data-testid={"vehicle-owner"}>{value.owner}</td>
          <td data-testid={"vehicle-payload"}>{value.payload}</td>
          <td data-testid={"vehicle-mileage"}>{value.mileage}</td>
          <td data-testid={"vehicle-estimatedvalue"}>
            £
            {typeof finance.estimated_value === "string"
              ? finance.estimated_value
              : (finance.estimated_value || 0).toFixed(2)}
          </td>
          <td data-testid={"vehicle-quote-status"} className={value.quote_status === "Active" ? "table-highlight-dark-red" : ""}>{value.quote_status}</td>
          <td><Button color="success" onClick={() => window.open(`/editrental?initVehicle=${value.id}`)}>Hire
            Contract</Button></td>
      </tr>
  );
}

export default HireReadyRow;
